export const presentation = [
  {
    path: '/presentation',
    component: () => import(/* webpackChunkName: "presentation" */ '@/views/presentation/Presentation'),
    children: [
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "presentation" */ '@/views/presentation/components/PresentationEditBody'),
      },
      {
        path: ':id/edit',
        component: () => import(/* webpackChunkName: "presentation" */ '@/views/presentation/components/PresentationEditBody'),
      },
      {
        path: ':id/persons',
        component: () => import(/* webpackChunkName: "presentation" */ '@/views/presentation/components/PresentationPersonsBody'),
      },
      {
        path: ':id/participations',
        component: () => import(/* webpackChunkName: "presentation" */ '@/views/presentation/components/PresentationParticipationsBody'),
      },
    ]
  },
]
